import { REDIRECT_URI } from '../constants';

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: '0644b401-dac4-483c-9f86-e042874f0e8e',
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: REDIRECT_URI
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true
  }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ['User.Read']
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};
